import React from 'react';
import { withStyles } from '@material-ui/core';
import MUSwitch from '../../ui/MUSwitch';
import MUTypography from '../../ui/MUTypography';
import MUList from '../../ui/MUList';
import MUListItem from '../../ui/MUListItem';
import MUListItemText from '../../ui/MuListItemText';
import styles from './style';

class APIsInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editPage: false,
      checked: [],
      readOnly: false
    };
  }

  handleToggle = (e, value) => {
    e.preventDefault();
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({ checked: newChecked });
    this.props.handleToggle(newChecked);
  };

  componentWillMount() {
    if (this.props.location.state !== undefined && this.props.editapplication) {
      const { appId, applications, readOnly } = this.props.location.state;
      Array.prototype.forEach.call(applications, value => {
        if (value.id === appId) {
          this.setState({
            editPage: true,
            checked: value.productList,
            readOnly: readOnly
          });
          this.props.onAPIsInfoLoad(value.productList);
        }
      });
    }
  }

  render() {
    const { classes, products } = this.props;
    const { editPage, checked, readOnly } = this.state;

    return (
      <div id='apis' style={{ display: 'flex', flexDirection: 'column', marginTop: '5%' }}>
        <div>
          <MUTypography className={classes.header} variant="headline" component="h2">
            {editPage ? 'APIs Used' : 'Available APIs'}
          </MUTypography>
          <MUTypography variant="headline" component="p" className={classes.p}>
            Below are the APIs to power your app. Activate with a single click to access the API product.
          </MUTypography>
        </div>
        <br />
        <div className="row">
          <div className={classes.scrollableList}>
            <MUList>
              {products && products.productList && products.productList.map((value) => (
                <MUListItem
                  key={value.id}
                  dense
                  button
                  className={classes.listItem}
                  onClick={(event) => this.handleToggle(event, value.id)}
                >
                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <MUListItemText
                      primary={
                        <MUTypography className={classes.apiTitle} component="p">
                          {value.name}
                        </MUTypography>
                      }
                      secondary={
                        <span className={classes.apiDescription}>
                          {value.summary}
                        </span>
                      }
                      style={{
                        flex: 1,
                        paddingRight: '16px',
                        overflow: 'hidden'
                      }}
                    />
                    <MUSwitch
                      onChange={(e) => this.handleToggle(e, value.id)}
                      checked={checked.indexOf(value.id) !== -1}
                      disabled={readOnly}
                      classes={{
                        switchBase: classes.colorSwitchBase,
                        checked: classes.colorChecked,
                        bar: classes.colorBar
                      }}
                    />
                  </div>
                </MUListItem>
              ))}
            </MUList>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(APIsInfo);
